import { combineReducers } from 'redux';

import address from './address/addressReducer';
import { maxWidthReducer as maxWidth } from './maxWidth';

export default combineReducers({
	address,
	maxWidth,
});
